namespace GeniuzPOS.Inventory {
    export enum TranTypeSelect {
        TranTypeSelect = 10,
        TranTypeSelect1 = 20,
        TranTypeSelect2 = 30,
        TranTypeSelect31 = 31,
        TranTypeSelect3 = 40,
        TranTypeSelect41 = 41,
        TranTypeSelect4 = 51,
        TranTypeSelect5 = 52,
        TranTypeSelect6 = 60,
        TranTypeSelect7 = 70
    }
    Serenity.Decorators.registerEnumType(TranTypeSelect, 'GeniuzPOS.Inventory.TranTypeSelect', 'Inventory.TranTypeSelect');
}
